var _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReadcv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m262.12,371.06c-3.69,0-7.43-.45-11.16-1.38l-178.22-44.44c-11.96-2.98-22.04-10.44-28.39-21-6.35-10.56-8.2-22.97-5.22-34.92l50.81-203.8c2.98-11.96,10.44-22.04,21-28.39,10.56-6.35,22.97-8.2,34.93-5.22l178.22,44.44c24.69,6.15,39.76,31.24,33.61,55.93l-50.81,203.8c-5.22,20.95-24.09,34.98-44.77,34.98ZM134.67,53.61c-4.13,0-8.21,1.12-11.84,3.3-5.28,3.17-9.01,8.21-10.5,14.19l-50.81,203.8c-1.49,5.98-.56,12.18,2.61,17.46,3.17,5.28,8.21,9.01,14.19,10.5l178.22,44.44c12.34,3.08,24.89-4.46,27.97-16.8l50.81-203.8c3.08-12.34-4.46-24.89-16.8-27.96l-178.23-44.44c-1.86-.46-3.75-.69-5.62-.69Z",
    fill: "#232224"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 204.34,
    y: 40.3,
    width: 23.07,
    height: 184.55,
    rx: 7,
    ry: 7,
    transform: "translate(35.01 309.97) rotate(-76)",
    fill: "#232224"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 191.76,
    y: 92.61,
    width: 23.07,
    height: 184.55,
    rx: 7,
    ry: 7,
    transform: "translate(-25.29 337.41) rotate(-76)",
    fill: "#232224"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 133.99,
    y: 176.59,
    width: 23.07,
    height: 92.28,
    rx: 7,
    ry: 7,
    transform: "translate(-105.8 310.05) rotate(-76)",
    fill: "#232224"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadcv);
export default __webpack_public_path__ + "static/media/readcv.67153b801887d5ded1f0d54cef3eed53.svg";
export { ForwardRef as ReactComponent };